<template>
  <div
    class="section"
    :class="baseClass"
    @click="onSectionClick"
    v-if="sectionData != null">
    <div class="card">
      <sec-heading
        :title="sectionData.label"
        :subtitle="sectionData.subtitle"
        :icon-type="sectionData.iconType"
        v-if="headingEnable"
        @head-click="onSectionClick"

      />
      <component
        :is="targetComp"
        :items-receive="items"
        :section-data="sectionData"
        :tag-id="sectionData.tagId"
      ></component>
    </div>
  </div>
</template>

<script>
import { MENU_SEC_TYPES, SEC_ICON_TYPE } from '@/CONSTS/MENUS'
import SecHeading from '@/utvStore/components/partials/SecHeading'
import SecTextList from '@/utvStore/components/partials/SecTextList'
import SecMovieList from '@/utvStore/components/partials/SecMovieList'
import SecVisTextA from '@/utvStore/components/partials/SecVisTextA'
import SecTodaysLucky7 from '@/utvStore/components/partials/SecTodaysLucky7'
import SecDetailView from '@/utvStore/components/partials/SecDetailView'

export default {
  name: "MenusSection",
  components: {
    SecHeading,
    SecTextList,
    SecMovieList,
    SecVisTextA,
    SecTodaysLucky7,
    SecDetailView
  },
  props: {
    idxInPage: {
      type: Number,
      default(){
        return -1
      }
    },
    sectionData: {
      type: Object,
      default() {
        return null
      }
    }
  },
  computed: {
    items() {
      return this.sectionData.items || []
    },
    headingEnable() {
      return this.sectionData.type !== MENU_SEC_TYPES.todays_lucky7 //todayslucky7のときは無効
    },
    targetComp() {
      switch (this.sectionData.type) {
        case MENU_SEC_TYPES.def_text: // 通常テキストメニュー
          return SecTextList
        case MENU_SEC_TYPES.def_movie: // 通常動画メニュー
          return SecMovieList
        case MENU_SEC_TYPES.vis_text_a: // ちょっと豪華なテキストメニューAタイプ
          return SecVisTextA
        case MENU_SEC_TYPES.counselor: //占い師(単品)
          return SecDetailView
        case MENU_SEC_TYPES.fortune: //占術(単品)
          return SecDetailView
        case MENU_SEC_TYPES.todays_lucky7: //TodaysLucky7
          return SecTodaysLucky7
        default:
      }
    },
    baseClass() {
      let classArr = []
      switch (this.sectionData.type) {
        case MENU_SEC_TYPES.def_text: // 通常テキストメニュー
          classArr.push('basic-section')
          break;
        case MENU_SEC_TYPES.def_movie: // 通常動画メニュー
          classArr.push('basic-section movie-list')
          break;
        case MENU_SEC_TYPES.counselor: //占い師(単品)
          classArr.push('basic-section')
          break;
        case MENU_SEC_TYPES.fortune: //占術(単品)
          classArr.push('basic-section')
          break;
        case MENU_SEC_TYPES.vis_text_a: // ちょっと豪華なテキストメニューAタイプ
          classArr.push('basic-section')
          break;
        case MENU_SEC_TYPES.todays_lucky7: //TodaysLucky7
          classArr.push('basic-section sec-lucky7')
          break;
      }
      if(this.sectionData.coloredBg){
        classArr.push('colored-bg')
      }
      return classArr.join(' ')
    },
  },
  mounted() {},
  methods: {
    onSectionClick() {
      let link = ''
      //占術・占い師は変わる予定
      if(!!this.sectionData && !!this.sectionData.categoryLink && this.sectionData.categoryLink.length > 0){
        link = this.sectionData.categoryLink
      }else {
        if(this.sectionData.type === MENU_SEC_TYPES.def_movie){
          // 2022/4/1リリース施策により動画は下層でリンクに変更
          link = `/tag/${this.sectionData.tagId}?movies=1`
        }else{
          if (+this.sectionData.tagId > 0) link = `/tag/${this.sectionData.tagId}${this.sectionData.type === MENU_SEC_TYPES.def_movie ? '?movies=1' : ''}`
        }
      }
      this.$emit('link-click', link)
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

$basic_side_padding: 20px;
$basic_top_padding: 25px;
$basic_bottom_padding: 20px;

.section {
  width: 100%;
  height: auto;
  color: $col_base_font;

  .card {
    width: 100%;
    height: 100%;
    background: $col_white_translucent;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    padding: 0 0 24px;
    cursor: pointer;
  }

  &.bacic-height {
    height: 180px;
  }
  &.basic-section {
    max-width: 580px;
    margin: auto;
    padding-top: $basic_top_padding;
    padding-bottom: $basic_bottom_padding;
    padding-left: $basic_side_padding;
    padding-right: $basic_side_padding;
  }
  &.colored-bg {
    // background: $col_colored_bg;
  }
  &.movie-list {
    pointer-events: none;
  }

  &.sec-lucky7 {
    .card {
      padding-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/MenusSection.vue